// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacePanelHeader__container-c92ef2 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 72px;
  padding: 0 12px;
}

.SpacePanelHeader__button-b2ff91 {
  margin-inline-end: 12px;
}

.SpacePanelHeader__avatar-da27a8 {
  margin-inline-end: 12px;
}

.SpacePanelHeader__title-wrapper-b3bc2c {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.SpacePanelHeader__title-b9e361 {
  color: var(--base-110);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.SpacePanelHeader__title-wrapper-b3bc2c {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  overflow: hidden;
}

.SpacePanelHeader__profile-cd8fca {
  margin-inline-start: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacePanel/SpacePanelHeader/SpacePanelHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  height: 72px;\n  padding: 0 12px;\n}\n\n.button {\n  margin-inline-end: 12px;\n}\n\n.avatar {\n  margin-inline-end: 12px;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  overflow: hidden;\n}\n\n.profile {\n  margin-inline-start: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpacePanelHeader__container-c92ef2`,
	"button": `SpacePanelHeader__button-b2ff91`,
	"avatar": `SpacePanelHeader__avatar-da27a8`,
	"title-wrapper": `SpacePanelHeader__title-wrapper-b3bc2c`,
	"titleWrapper": `SpacePanelHeader__title-wrapper-b3bc2c`,
	"title": `SpacePanelHeader__title-b9e361`,
	"profile": `SpacePanelHeader__profile-cd8fca`
};
module.exports = ___CSS_LOADER_EXPORT___;
